<template>
    <div ref="box" style="display:none;">
        <!-- 头部 -->
        <div class="bar-manager-header">
            <bar-header
                @refresh="refresh"
                @setDirectAndSpareModal="setDirectAndSpareModal"
            ></bar-header>
        </div>
        <div class="bar-content">
            <!-- 表格部分 -->
            <div class="bar-left">
                <table-content ref="table"></table-content>
            </div>
            <div class="bar-right">
                <content-right ref="right"></content-right>
            </div>
        </div>
    </div>
</template>

<script>
// 头部tag内容
import BarHeader from "./barHeader";
// 左侧表格内容
import TableContent from "./tables";
// 右侧内容
import ContentRight from "./contentRight";

export default {
    name: "recentRemote",
    components: {
        BarHeader,
        TableContent,
        ContentRight
    },
    data() {
        return {
            total: 0,
            page: 1,
            tableData: {
                list: []
            }
        };
    },
    mounted() {
        this.$nextTick(() => {
            setTimeout(() => {
                this.$refs.box.style.display = "block";
            });
        });
    },
    methods: {
        setDirectAndSpareModal() {
            this.$emit("setDirectAndSpareModal");
        },
        refresh() {
            this.$refs.table.init();
            this.$refs.right.init();
        }
    }
};
</script>

<style lang="scss" scoped>
@import "_style/_color.scss";
@import "_style/cssfn/common.scss";

.bar-manager-header {
    height: 70px;
    line-height: 70px;
    border-bottom: 1px solid #d9dee4;
}
.bar-content {
    padding-top: 10px;
    text-align: left;
    @include clearfix();
}
.bar-left {
    // padding-left: 30px;
    float: left;
    width: 68%;
    // min-width: 800px;
}
.bar-right {
    float: left;
    width: 32%;
    // min-width: 380px;
    // padding-right: 30px;
}
.table-pagination {
    text-align: right;
    padding-right: 80px;
    padding-top: 20px;
    > div {
        display: inline-block;
    }
}
.table-list {
    margin-top: 10px;
}
</style>
